module.exports = __webpack_public_path__ + "static/img/subtitle.f28d2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/subtitle.png
// module id = BZVh
// module chunks = 1